export default __webpack_public_path__ + "static/media/left_creative_mob.76350e81.png";